require('./bootstrap')

import Vue from 'vue'
import { FvlForm, FvlInput, FvlMultiFile, FvlSelect, FvlSubmit, FvlTextarea } from 'formvuelar'

import scrollToAnchor from 'scroll-to-anchor'

const FORM_SELECTOR = '#quote-form'

const FORM = {
    name: '',
    phone: '',
    email: '',
    text: '',
    product: '',
    quantity: '',
    // Button
    buttonStyle: '',
    buttonSize: '',
    // Wristband
    wristbandStyle: '',
    wristbandSize: '',
    // Lapel Pin
    pinStyle: '',
    pinSize: '',
    // Lanyard
    lanyardType: '',
    lanyardSize: '',
    lanyardAttachment: '',

    comments: '',
    files: [],
}

const app = new Vue({
    el: '#quote-form',
    components: {
        FvlForm,
        FvlSelect,
        FvlInput,
        FvlSubmit,
        FvlTextarea,
        FvlMultiFile
    },

    data () {

        return {
            formSuccess: false,
            successMessage: '',
            submitDisabled: false,
            form: FORM,
            option: {
                'Buttons': 'Buttons',
                'Wristbands': 'Wristbands',
                'Lapel Pins': 'Lapel Pins',
                'Lanyards': 'Lanyards'
            },
            // Button Selections
            buttonStyles: { 'Round': 'Round', 'Shape': 'Shape', 'Blinking': 'Blinking', 'Custom': 'Custom', },
            buttonSizes: {
                '1 1/4 inch': '1 1/4 Inch',
                '1 1/2 inch': '1 1/2 Inch',
                '1 3/4 inch': '1 3/4 Inch',
                '2 1/4 inch': '2 1/4 Inch',
                '2 1/2 inch': '2 1/2 Inch',
                '2 3/4 inch': '2 3/4 Inch',
                '3 inch': '3 Inch',
                '3 1/4 inch': '3 1/4 Inch',
                '3 1/2 inch': '3 1/2 Inch',
                '3 3/4 inch': '3 3/4 Inch',
                '4 inch': '4 Inch',
                '4 1/4 inch': '4 1/4 Inch',
                '4 1/2 inch': '4 1/2 Inch',
                '4 3/4 inch': '4 3/4 Inch',
                '5 inch': '5 Inch',
                '5 1/4 inch': '5 1/4 Inch',
                '5 1/2 inch': '5 1/2 Inch',
                '5 3/4 inch': '5 3/4 Inch',
                '6 inch': '6 Inch'
            },
            // Wristband Selections
            wristbandStyles: {
                'Debossed': 'Debossed',
                'Silkscreened': 'Silkscreened',
                'Segmented': 'Segmented',
                'Swirled': 'Swirled',
                'Embossed': 'Embossed',
                'Debossed Painted': 'Debossed Painted'
            },
            wristbandSizes: { 'Child': 'Child', 'Youth': 'Youth', 'Adult': 'Adult' },
            // Lapel Pin Selections
            pinStyles: {
                'Cloisonne': 'Cloisonne',
                'Soft Enamel': 'Soft Enamel',
                'Die Struck': 'Die Struck',
                'Silkscreened': 'Silkscreened',
                'Photo Etched': 'Photo Etched',
                'Offset Digital': 'Offset Digital'
            },
            pinSizes: {
                '.75 inch': '.75 Inch',
                '1 inch': '1 Inch',
                '1.25 inch': '1.25 Inch',
                '1.50 inch': '1.50 Inch',
                '1.75 inch': '1.75 Inch',
                '2 inch': '2 Inch'
            },
            // Lanyard Selections
            lanyardTypes: { 'Polyester': 'Polyester', 'Woven': 'Woven', 'Nylon': 'Nylon', 'Tubular': 'Tubular' },
            lanyardSizes: { '5/8 inch': '5/8 Inch', '3/4 inch': '3/4 Inch', '1 inch': '1 Inch' },
            lanyardAttachments: {
                'Bulldog Clip': 'Bulldog Clip',
                'Swivel J Hook': 'Swivel J Hook',
                'Key Ring': 'Key Ring',
                'Thumb Trigger': 'Thumb Trigger'
            },
        }
    },
    methods: {
        onSuccess (e) {
            this.submitDisabled = false
            this.successMessage = e.data.message
            this.formSuccess = true
            scrollToAnchor(FORM_SELECTOR, { behavior: 'smooth', alignToTop: true })
        },
        onRequestStarted(){
            this.submitDisabled = true
        },

        onError (e) {
            console.log('[name=' + Object.keys(e.data.errors)[0] + ']');

            scrollToAnchor('[name=' + Object.keys(e.data.errors)[0] + ']', { behavior: 'smooth', alignToTop: true })
            this.submitDisabled = false
        }
    }
})


